import { createSelector } from '@reduxjs/toolkit';
import { emptyObj } from '@beef/utils';
import { getModulesData } from "../selectors";
export var selectCallbackData = function selectCallbackData(state) {
  return getModulesData(state).callbackRequest;
};
export var selectUserCtn = function selectUserCtn(state) {
  return selectCallbackData(state).ctn;
};
export var selectIsCorrectCtn = function selectIsCorrectCtn(state) {
  return selectUserCtn(state).length === 10;
};
export var selectIsCtnError = function selectIsCtnError(state) {
  return selectCallbackData(state).isCtnError;
};
export var selectIsCaptchaError = function selectIsCaptchaError(state) {
  return selectCallbackData(state).isCaptchaError;
};
export var selectCaptchaRequired = function selectCaptchaRequired(state) {
  return selectCallbackData(state).isCaptchaRequired;
};
export var selectRefreshCaptcha = function selectRefreshCaptcha(state) {
  return selectCallbackData(state).refreshCaptcha;
};
export var selectCaptchaValue = function selectCaptchaValue(state) {
  return selectCallbackData(state).captchaValue;
};
export var selectCaptchaKey = function selectCaptchaKey(state) {
  return selectCallbackData(state).captchaKey;
};
export var selectCaptchaData = createSelector([selectCaptchaValue, selectCaptchaKey], function (captchaToken, key) {
  return {
    captchaToken: captchaToken,
    key: key
  };
});

// Чекбокс отображается если настройка PersonalVerificationCheckboxEnable==true
export var selectPersonalVerificationCheckboxEnableData = function selectPersonalVerificationCheckboxEnableData(state) {
  return selectCallbackData(state).fttbPersonalVerificationCheckboxEnable || emptyObj;
};
export var selectIsFttbPersonalVerificationCheckboxEnable = function selectIsFttbPersonalVerificationCheckboxEnable(state) {
  return selectPersonalVerificationCheckboxEnableData(state).personalVerificationCheckboxEnable;
};